import React from 'react';
import { useParamSystemService } from '../services/param-system-service';

export const MapReponserMethod = {
  WEBCHAT: 'WEBCHAT',
  QUESTIONARIO: 'QUESTIONARIO',
};

export const useParamSystemController = () => {
  const { getRequestMethodByInterview } = useParamSystemService();

  const findRequestMethodByInterview = React.useCallback(
    (idInterview) => {
      return getRequestMethodByInterview(idInterview)
        .then((data) => data)
        .catch((error) => {
          throw error;
        });
    },
    [getRequestMethodByInterview],
  );

  return {
    findRequestMethodByInterview,
  };
};
